import { render, staticRenderFns } from "./PatientDetail.vue?vue&type=template&id=5a1456e4&scoped=true&"
import script from "./PatientDetail.vue?vue&type=script&lang=js&"
export * from "./PatientDetail.vue?vue&type=script&lang=js&"
import style0 from "./PatientDetail.vue?vue&type=style&index=0&id=5a1456e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1456e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VContainer,VFlex,VIcon,VLayout,VSpacer})
